import { Frequency } from "@emi/shared/models";

export const DatePicker:
    {
        MAX_ALLOWED_YEARS_AGO: number,
        DATE_RANGE_LIMITS: { frequency: Frequency, skuCountLower: number, skuCountUpper: number, maxSelectableDays: number, message: string }[],
        DEFAULT_SELECTED_DAYS_AGO: number,
        DEFAULT_MAX_DATE_DAYS_AGO: number
    } = {

    MAX_ALLOWED_YEARS_AGO: 3,

    DEFAULT_SELECTED_DAYS_AGO: 90,

    DEFAULT_MAX_DATE_DAYS_AGO: 2,

    DATE_RANGE_LIMITS: [
        {
            frequency: 'Daily',
            skuCountLower: 1,
            skuCountUpper: 10000,
            maxSelectableDays: Number.MAX_VALUE,
            message: ''
        },
        {
            frequency: 'Daily',
            skuCountLower: 10001,
            skuCountUpper: 50000,
            maxSelectableDays: 731,
            message: 'You can only select up to 2 years of data for daily frequency.'
        },
        {
            frequency: 'Daily',
            skuCountLower: 50001,
            skuCountUpper: 100000,
            maxSelectableDays: 366,
            message: 'You can only select up to 1 year of data for daily frequency.'
        },
        {
            frequency: 'Daily',
            skuCountLower: 100001,
            skuCountUpper: 250000,
            maxSelectableDays: 123,
            message: 'You can only select up to 4 months of data for daily frequency.'
        },
        {
            frequency: 'Daily',
            skuCountLower: 250001,
            skuCountUpper: 500000,
            maxSelectableDays: 62,
            message: 'You can only select up to 2 months of data for daily frequency.'
        },
        {
            frequency: 'Daily',
            skuCountLower: 500001,
            skuCountUpper: 1000000,
            maxSelectableDays: 31,
            message: 'You can only select up to 1 months of data for daily frequency.'
        },
    ],
}